import { MdsIcon } from '@mds/icons';

export enum InformationRequestTabValues {
  INCOMING = 'INCOMING',
  OUTGOING = 'outgoing',
}

export const INFORMATION_REQUESTS_TABS = [
  {
    value: InformationRequestTabValues.INCOMING,
    icon: MdsIcon.DOWNSTREAM,
    label: 'Incoming',
    disabled: false,
    ariaLabel: 'Incoming',
  },
  {
    value: InformationRequestTabValues.OUTGOING,
    icon: MdsIcon.ARROW_OUTWARD,
    label: 'Outgoing',
    disabled: false,
    ariaLabel: 'Outgoing',
  },
];
